import { render, staticRenderFns } from "./KvImageCrop.vue?vue&type=template&id=2181b4c2&"
import script from "./KvImageCrop.vue?vue&type=script&lang=js&"
export * from "./KvImageCrop.vue?vue&type=script&lang=js&"
import style0 from "./KvImageCrop.vue?vue&type=style&index=0&id=2181b4c2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/kivateknoloji/kivacloud/corona-ux/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2181b4c2')) {
      api.createRecord('2181b4c2', component.options)
    } else {
      api.reload('2181b4c2', component.options)
    }
    module.hot.accept("./KvImageCrop.vue?vue&type=template&id=2181b4c2&", function () {
      api.rerender('2181b4c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/kiva/kv-image-crop/KvImageCrop.vue"
export default component.exports